export default __webpack_public_path__ + "static/media/cyber-man-under-bridge.3f8cb80a.jpg";